export const GET_NEW_REVENUE = "GET_NEW_REVENUE"
export const GET_NEW_REVENUE_SUCCESS = "GET_NEW_REVENUE_SUCCESS"
export const GET_NEW_REVENUE_FAIL = "GET_NEW_REVENUE_FAIL"